/**
 * @typedef {Object} AuthenticationOptions
 * cancelLabel - Label for the cancel button
 * disableDeviceFallback - Disable the device fallback
 * fallbackLabel - Label for the fallback button
 * promptMessage - Message to show in the prompt
 * requireConfirmation - Require confirmation
 */
export type AuthenticationOptions = {
  cancelLabel?: string;
  disableDeviceFallback?: boolean;
  fallbackLabel?: string;
  promptMessage?: string;
  requireConfirmation?: boolean;
};
